import { defineStore } from 'pinia';
import { ref } from 'vue';

/** Ce qu'affiche la fête de signature ; `quoteId` est null pour un essai local (Réglages). */
export interface Celebration {
  quoteId: string | null;
  clientName: string;
  amountCents: number;
  description: string;
}

/** Fête de signature affichée par `SignatureParty` (événement SSE `quote.signed` ou essai). */
export const useCelebrationStore = defineStore('celebration', () => {
  const current = ref<Celebration | null>(null);
  function celebrate(value: Celebration): void {
    current.value = value;
  }
  function close(): void {
    current.value = null;
  }
  return { current, celebrate, close };
});
